import { combineReducers } from 'redux';
import register from './register';
import modify from './modify';
import loginEmail from './loginEmail';
import loginSSO from './loginSSO';
import user from './user';

const ssoReducer = combineReducers({
  register,
  modify,
  loginEmail,
  loginSSO,
  user,
});

export default ssoReducer;
